<template>
<div>

  <div id="window-panel">

    <!-- sticky header -->
    <div id="order-header">
      <a class='pfm-button icon inline' href='javascript:' @click="backToShop">
        <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#90949A" fill-rule="nonzero" d="M21.2 5.43L18.778 3 6.8 15l11.977 12 2.423-2.43L11.653 15z"/></svg>
        <span class='label'>Zpět do obchodu</span>
      </a>
      <div id="order-total-head" class='highlight total-price'>
        <span id='order-total-price' class=''>{{cartData.total | formatPrice}}</span>
        <!-- <h3>total</h3> -->
        <!-- <select name="currency" if="total-currency">
            <option value="CZK" selected="true">CZK</option>
          </select> -->
      </div>
    </div>

    <div id='order-page-title'>
      <h2>Váza</h2>
    </div>

    <!-- Top part is about products -->
    <product-list v-if="cartData.products != null" :products="cartData.products" @productUpdated="productUpdated" @removed="productRemoved" />

    <!-- Entering some discount codes -->

    <!-- <div v-if="cartData.cartId && cartData.products && cartData.products.length > 0"> -->
    <div v-if="cartData.products && cartData.products.length > 0">
      <!-- Now is proper time to identify user -->
      <div id="login">
        <identification @change="updatedIdentification" :mainCart="mainCart" />
      </div>

      <!-- And now we can add details about shipping, delivery and payment -->
      <div id="order-details" v-if="showForm">
        <!-- {{cartData.delivery}}|{{shopData && shopData.payments.modules}} -->

        <cart-form :cart="cartData" :shopData="shopData" @updated="cartUpdated" />

      </div>

      <div id="order-details-loading" v-if="mainCart.data.rulesAccepted && !mainCart.cartLoaded">
        <div class='animation-wrap loading'>
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#90949A" d="M25 5a20.14 20.14 0 0120 17.88 2.51 2.51 0 002.49 2.26A2.52 2.52 0 0050 22.33a25.14 25.14 0 00-50 0 2.52 2.52 0 002.5 2.81A2.51 2.51 0 005 22.88 20.14 20.14 0 0125 5z"/></svg>
        </div>
      </div>
    </div>
  </div>

  <error-msg v-if="mainCart.cartLoaded
                  && !mainCart.orderClosed
                  && !cartData.cartId && cartData.temporaryCart
                  && !cartData.orderNumber" :data="{msg: 'Není aktivní žádná objednávka asd'}" />

  <!-- <error-msg v-if="mainCart.cartLoaded && mainCart.orderClosed" :data="{msg: 'Objednávku již není možné zpracovat'}" /> -->

</div>
</template>

<script>
import Notification from '@/notification';
import Locale from '@/langs';
import Utils from '@/utils';

import Cart from '@/cart';
import User from '@/service/user'; // For checking user status

import ErrorMsg from './Error';
import ProductList from './ProductList';
import Identification from './Identification';
import CartForm from './order/CartForm';

export default {
  name: 'Order',
  components: {
    ErrorMsg,
    ProductList,
    Identification,
    CartForm
  },
  data() {
    return {
      user: User.context,
      cartData: Cart.data,
      mainCart: Cart,
      cartTemporary: Cart.temporaryCart,
      showForm: Cart.data.rulesAccepted && Cart.cartLoaded,
      shopData: Cart.shopData,
      order: null,
      cartSnapshotChanged: null,
      // showForm: cartData.cartId || cartData.temporaryCart) && cartData.products && cartData.products.length > 0
    };
  },
  // computed: {
  //   showForm() {
  //     return
  //   }
  // },
  watch: {
    cartTemporary: {
      deep: true,
      handler() {
        console.log('Cart updated')
      }
    },
  },
  created() {
    // this.mainCart.cartLoaded = true

    let storedPhase = window.localStorage.getItem('phase')
    console.log('Entering order view', storedPhase)

    if (storedPhase) {
      Cart.siteState = storedPhase
      if (['awaiting-verification', 'setting-email'].includes(storedPhase)) {
        console.log('Site loaded with some previous login pahse', storedPhase)
        this.showForm = false
      }
    }
  },
  methods: {
    productUpdated(prodId) {
      Cart.saveCart({
          hide: true,
          calculate: true
        })
        .then(result => {
          if (result) {
            this.$emit('updatedCart')
          }
        })
    },
    productRemoved(prodId) {
      Cart.saveCart({
          hide: true,
          calculate: true
        })
        .then(result => {
          console.log('Cart saved after product removal', result)
          if (result) {
            this.$emit('updatedCart')
          }
        })
    },
    updatedIdentification() {
      console.log('updatedIdentification(accepted)', this.user.authenticated, this.user.isNew)
      this.showForm = this.user.authenticated || this.user.isNew
      Cart.saveCart({})
    },
    cartUpdated(instructions) {
      Cart.saveCart(instructions)
    },
    backToShop() {
      parent.postMessage({action: 'backToShop'}, '*')
      console.log('clicked back to shop')
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import '../variables.less';

#window-panel {
    #order-header {
      // background: @pfm-cart-bg;
      background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 1%,rgba(255,255,255,0) 100%);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      // outline: 1px solid #ff0000;
      padding: 20px;
      z-index: 10;
    }

    #order-total-head {
      span#order-total-price {
        white-space: nowrap;
      }
    }

    #login {
      margin-top: 30px;
    }

    #order-details-loading {
      .animation-wrap.loading {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        padding-top: 10px;

          svg {
              animation: spin 1s linear infinite;
              width: 24px;
              height: 24px;
          }
      }
    }
}
</style>
